import { useMutation } from '@apollo/client';
import {
    DeleteWorldMap,
    DeleteWorldMapVariables
} from 'graphql/mutation/__generated__/DeleteWorldMap';
import { DELETE_WORLD_MAP_MUTATION } from 'graphql/mutation/worldMutation';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { useContext } from 'react';
import { GlobalContext } from 'session/state/context';

export const useDeleteMap = () => {
    const { state } = useContext(GlobalContext);
    const { getTokenForMapId } = useWorldMapLocalStorage();

    const [delteWorldMapMutation] = useMutation<DeleteWorldMap, DeleteWorldMapVariables>(
        DELETE_WORLD_MAP_MUTATION
    );

    function del(mapId: string) {
        if (state.loggedUserChecked && !state.loggedUser) {
            return;
        }
        return delteWorldMapMutation({
            variables: {
                worldMapId: mapId,
                token: getTokenForMapId(mapId)
            },
            onCompleted: (result) => {
                return result;
            },
            update: (cache) => {
                const removeId = cache.identify({
                    __typename: 'WorldMap',
                    worldMapId: mapId
                });
                cache.evict({ id: removeId });
                cache.gc();
            }
        });
    }

    return {
        del
    };
};
